<div id="deviceIOCard" class="control-card-white">
  <div class="control-card-header">
    <ng-container i18n="@@deviceio_title">I/O dispositivo</ng-container>
    <fa-icon icon="times" class="float-right margin-right-20 icon-clickable" (click)="closeDialog()"></fa-icon>
  </div>

  <div class="control-card-content">
    <div class="table-container">
      <div class="scrollable-wrapper">
        <table class="simple-table">
          <thead>
            <th i18n="@@deviceioseditor_number">Numero</th>
            <th i18n="@@deviceioseditor_type">Tipo</th>
            <th i18n="@@deviceioseditor_mode">Modo</th>
            <th i18n="@@deviceioseditor_name">Nome</th>
            <th></th>
          </thead>

          <tbody [formGroup]="iosForm">
            <ng-container formArrayName="items">
              <tr *ngFor="let itemForm of items.controls; index as i">
                <ng-container [formGroup]="itemForm">
                  <!-- <td>
                    <select formControlName="number">
                      <option *ngFor="let number of numbersList" [ngValue]="number">
                        {{ number }}
                      </option>
                    </select>
                  </td> -->
                  <td>
                    <input formControlName="number" type="number" min="0" max="80" />
                  </td>
                  <td>
                    <select formControlName="typeString">
                      <option *ngFor="let typeString of typeList" [ngValue]="typeString">
                        {{ typeString.text }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select formControlName="mode">
                      <option *ngFor="let mode of modeList" [ngValue]="mode">
                        {{ mode }}
                      </option>
                    </select>
                  </td>

                  <td>
                    <input formControlName="name" type="text" />
                  </td>
                </ng-container>
                <td>
                  <div class="io-table-buttons">
                    <fa-icon icon="minus-circle" class="icon-clickable" (click)="deleteItem(i)">
                    </fa-icon>
                  </div>
                </td>
              </tr>
            </ng-container>

            <tr>
              <td colspan="4">
                <div class="io-table-buttons">
                  <fa-icon icon="plus-circle" class="icon-clickable" (click)="addEmptyItem()">
                  </fa-icon>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="control-card-buttons">
    <a (click)="saveIOs()" class="button">
      <ng-container i18n="@@deviceioseditor_save_ios">Salva Modifiche</ng-container>
      <span>
        <fa-icon icon="save"></fa-icon>
      </span>
    </a>

    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="numberError"
      i18n="@@deviceioseditor_numberError_ios">
      Non puoi inserire lo stesso numero in più I/O
    </p>
    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="typeError"
      i18n="@@deviceioseditor_typeError_ios">
      Non puoi inserire lo stesso tipo in più I/O
    </p>

    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="tooManyError"
      i18n="@@deviceioseditor_tooManyError_ios">
      Il numero massimo di I/O è 80
    </p>

    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="notNumberError"
      i18n="@@deviceioseditor_notNumberError_ios">
      Ad ogni I/O è necessario assegnare un identificativo numerico
    </p>

    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="negativeNumberError"
      i18n="@@deviceioseditor_negativeNumberError_ios">
      Ad ogni I/O è necessario assegnare un identificativo numerico non negativo
    </p>

    <p class="text-small text-error margin-top-10 margin-left-20 display-inline" *ngIf="inpOtherOnBusError"
      i18n="@@deviceioseditor_inpOtherOnBusError_ios">
      Non è possibile associare il tipo inp-other su modalità BUS
    </p>
  </div>

  <app-loading-screen #ioloader [loading]="false"></app-loading-screen>
</div>
